import React from 'react'
import CityAutocomplete from './city'
import caretDown from './images/caretDownGeneric.svg'
import PostalCodeAutocomplete from './PostalCode'
import StateAutocomplete from './state'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../Images/circle-info-regular-full.svg'

function Location ({
  localStreetAddress,
  setLocalStreetAddress,
  localCity,
  setLocalCity,
  localState,
  setLocalState,
  localPostalCode,
  setLocalPostalCode,
  localCountry,
  setLocalCountry
}) {
  const handleStreetChange = event => {
    setLocalStreetAddress(event.target.value)
  }

  const handleCountryChange = event => {
    setLocalCountry(event.target.value)
  }

  return (
    <div className={styles.locationSection}>
      <h1 className={styles.locationTitle}>Location</h1>
      <div className={styles.locationInputContainer}>
        {/* Street Address with Tooltip */}
        <div className={styles.locationInputWrapper}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            <label
              className={styles.locationLabel}
              htmlFor='prevent_autofill_street'
            >
              Street address
            </label>
            <Tooltip
              title='Filter by street address.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Street address help'
                width={14}
                height={14}
                style={{ cursor: 'pointer' }}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.locationInput}
            type='text'
            id='prevent_autofill_street'
            autoComplete='off'
            placeholder='Text'
            value={localStreetAddress}
            onChange={handleStreetChange}
          />
        </div>

        <CityAutocomplete localCity={localCity} setLocalCity={setLocalCity} />
        <StateAutocomplete
          localState={localState}
          setLocalState={setLocalState}
        />
        <PostalCodeAutocomplete
          localPostalCode={localPostalCode}
          setLocalPostalCode={setLocalPostalCode}
        />

        {/* Country with Tooltip */}
        <div className={styles.locationInputWrapper}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            <label className={styles.locationLabel} htmlFor='country'>
              Country
            </label>
            <Tooltip
              title='Filter by country.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Country help'
                width={14}
                height={14}
                style={{ cursor: 'pointer' }}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <div>
            <select
              className={styles.locationInputDropBox}
              name='countries'
              id='country'
              value={localCountry}
              onChange={handleCountryChange}
            >
              <option value=''>Any</option>
              <option value='US'>US</option>
              <option value='CA'>Canada</option>
            </select>
            <img
              src={caretDown}
              alt='arrow'
              className={styles.customArrowPrice}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Location
